import React from "react";
import PropTypes from "prop-types";
import makeAnimated from "react-select/animated";

import { InputGroup } from "@chakra-ui/react";
import TldrChakraSelect from "./TldrChakraSelect";

export const customStyles = {
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),
  control: (provided) => ({
    ...provided,
    width: "100%",
    cursor: "pointer",
    color: "brand.white",
    background: "brand.dark",
    border: "1px solid",
    borderColor: "gray.1000",
    borderRadius: "8px",
    _focus: {
      borderColor: "gray.1000",
      background: "brand.darker",
      color: "brand.white",
    },
    _hover: {
      borderColor: "gray.1000",
      background: "brand.darker",
      color: "brand.white",
      cursor: "text",
    },
    _invalid: {
      borderColor: "brand.negative",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "gray.300",
  }),
  input: (provided) => ({
    ...provided,
    color: "gray.100",
    background: "transparent",
  }),
  valueContainer: (provided) => ({
    ...provided,
    paddingX: 2,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    bg: null,
    color: "gray.100",
    paddingX: 2,
    fontSize: "xl",
    borderColor: "transparent",
    "> svg": {
      width: "1em",
      height: "1em",
    },
    height: "24px",
    borderRadius: "4px",
    marginLeft: "5px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  menu: (provided) => ({
    ...provided,
    minWidth: "100%",
    width: "initial",
    boxShadow: "dark-lg",
  }),
  menuList: (provided) => ({
    ...provided,
    background: "brand.grey-darker",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    color: state.isSelected
      ? "primary.400"
      : state.isDisabled
      ? "gray.300"
      : "gray.100",
    _hover: {
      color: state.isSelected
        ? "primary.400"
        : state.isDisabled
        ? "gray.300"
        : "brand.white",
      backgroundColor: state.isDisabled ? "transparent" : "gray.1200",
    },
  }),
};

export const customStylesForResultsView = {
  ...customStyles,
  control: (provided, state) => ({
    ...provided,
    height: "40px",
    width: "100%",
    cursor: "pointer",
    color: "brand.white",
    background: "brand.dark",
    border: "1px solid",
    borderColor: "gray.1000",
    borderRadius: "8px",
    _focus: {
      borderColor: "gray.1000",
      background: "brand.darker",
      color: "brand.white",
    },
    _hover: {
      borderColor: "gray.1000",
      background: "brand.darker",
      color: "brand.white",
      cursor: "text",
    },
  }),
};

function TldrSelect(props) {
  const { options, defaultOption } = props;
  const selectedOption = defaultOption
    ? options.filter(function (option) {
        return option.value === defaultOption;
      })
    : [options[0]];
  const animatedComponents = makeAnimated();

  return (
    <>
      <InputGroup>
        <TldrChakraSelect
          onChange={props.onSelect}
          isLoading={false}
          chakraStyles={
            props.resultsView ? customStylesForResultsView : customStyles
          }
          // components={animatedComponents}
          defaultValue={selectedOption}
          value={props.options.find(ele => ele.value === props.value)}
          name="colors"
          options={options}
          classNamePrefix="select"
        />
      </InputGroup>
    </>
  );
}

TldrSelect.propTypes = {
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default TldrSelect;
